import { createContext, useContext } from "react";
import type { WidgetVariant } from "@/types";

const defaultVariant: WidgetVariant = "on-site";

export const WidgetVariantContext = createContext<WidgetVariant | undefined>(
  undefined
);

export function useWidgetVariant(): WidgetVariant {
  const variant = useContext(WidgetVariantContext);
  return variant ?? defaultVariant;
}
